// extracted by mini-css-extract-plugin
export default {"button":"CustomBulkDeleteButton_button__ZBIv6"};